// Depth (as a local y for depthAt) of the farm's two FRONT fence runs. An object is sorted by the
// bottom corner of its front cell (+1, FarmObjectLayer) — lower than the middle of that cell's edge,
// where a rail sits — so a Kurnik against the front fence was drawn over it (owner 2026-09-30). A
// front rail / post must beat anything standing in its edge cell: rails sit a quarter tile above
// that cell's bottom corner, posts at most half a tile above it.
import { TILE_H } from './iso.mjs';

export const FRONT_BIAS = 2;
export const frontRailY = (midY) => midY + TILE_H / 4 + FRONT_BIAS + 1;
export const frontPostY = (cornerY) => cornerY + TILE_H / 2 + FRONT_BIAS + 1;
